document.addEventListener('DOMContentLoaded', (event) => {


	if ($('.ShopTheLook').length) {
		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('ShopTheLook__Dot') || el.closest('.ShopTheLook__Dot')) {
				if (!el.classList.contains('ShopTheLook__Dot')) {
					el = el.closest('.ShopTheLook__Dot');
				}
				e.preventDefault();
				const windowWidth = window.innerWidth;
				if (windowWidth <= 1024) {

					const ShopTheLookSectionWrapper = el.closest('.ShopTheLook');

					const ShopTheLook__DotsWrapperEl = el.closest('.ShopTheLook__DotsWrapper');
					const prevActiveEl = ShopTheLook__DotsWrapperEl.querySelector('.ShopTheLook__ProductWrapper.is-active');
					let prevActiveEl_Index = null;
					if (prevActiveEl) {
						prevActiveEl.classList.remove('is-active');
						prevActiveEl_Index = prevActiveEl.getAttribute('data-product-index') * 1;

						ShopTheLookSectionWrapper.classList.remove('active_dot');
					}

					const parentEl = el.closest('.ShopTheLook__ProductWrapper');
					if (parentEl) {
						let parentEl_Index = parentEl.getAttribute('data-product-index') * 1;
						if (parentEl_Index != prevActiveEl_Index) {
							parentEl.classList.toggle('is-active');

							if (parentEl.classList.contains('is-active')) {
								ShopTheLookSectionWrapper.classList.add('active_dot');
							} else {
								ShopTheLookSectionWrapper.classList.remove('active_dot');
							}
						}
					}

				}
			}
		});
		document.addEventListener('click', function(e) {
			let el = e.target;

			if (el.classList.contains('ShopTheLook__Product__close_btn') || el.closest('.ShopTheLook__Product__close_btn')) {
				if (!el.classList.contains('ShopTheLook__Product__close_btn')) {
					el = el.closest('.ShopTheLook__Product__close_btn');
				}

				e.preventDefault();
				const parentEl = el.closest('.ShopTheLook__ProductWrapper');
				const ShopTheLookSectionWrapper = el.closest('.ShopTheLook');

				if (parentEl) {
					parentEl.classList.toggle('is-active');
					ShopTheLookSectionWrapper.classList.remove('active_dot');
				}
			}
		});
		const isItIn = function(parent, child) {
			const box1coords = parent.getBoundingClientRect();
			const box2coords = child.getBoundingClientRect();

			let isOverlap = false;
			let overlapSide = {};


			if (box2coords.top < box1coords.top) {
				overlapSide.top = true;
				isOverlap = true;
			}
			if (box2coords.right > box1coords.right) {
				overlapSide.right = true;
				isOverlap = true;
			}
			if (box2coords.left < box1coords.left) {
				overlapSide.left = true;
				isOverlap = true;
			}
			if (box2coords.bottom > box1coords.bottom) {
				overlapSide.bottom = true;
				isOverlap = true;
			}

			if (isOverlap) {
				return overlapSide;
			} else {
				return false;
			}


		}

		function ShopTheLook__ProductReposition() {
			const ShopTheLook__ProductArr = document.querySelectorAll('.ShopTheLook__Product');
			if (ShopTheLook__ProductArr.length) {
				ShopTheLook__ProductArr.forEach(function(item, index) {

					item.classList.remove('repositioned');
					item.classList.remove('top');
					item.classList.remove('left');
					item.classList.remove('right');
					item.classList.remove('bottom');

					const parentEl = item.closest('.ShopTheLook__Item');
					if (isItIn(parentEl, item)) {
						const response = isItIn(parentEl, item);

						for (key in response) {
							item.classList.add(key);
						}
						item.classList.add('repositioned');
					}
				});
			}
		}
		ShopTheLook__ProductReposition();
		window.addEventListener("resize", debounce(function(e) {
			ShopTheLook__ProductReposition();
		}));
		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('ShopTheLook__modal_btn') || el.closest('.ShopTheLook__modal_btn')) {
				if (!el.classList.contains('ShopTheLook__modal_btn')) {
					el = el.closest('.ShopTheLook__modal_btn');
				}

				e.preventDefault();
				const modalId = el.getAttribute('data-href-id');
				const modalEl = document.querySelector('#' + modalId);

				if (modalEl) {
					modalEl.classList.add('active');
					document.body.classList.add('popup-open');
				}
			}
		});


		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('ShopTheLook__Product_Link') || el.closest('.ShopTheLook__Product_Link')) {
				if (!el.classList.contains('ShopTheLook__Product_Link')) {
					el = el.closest('.ShopTheLook__Product_Link');
				}

				e.preventDefault();

				const modalEl = document.querySelector('.ShopTheLook__modal.active');

				if (modalEl) {
					modalEl.classList.remove('active');
					document.body.classList.remove('popup-open');
				}
			}
		});
		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('ShopTheLook__modal_close') || el.closest('.ShopTheLook__modal_close')) {
				if (!el.classList.contains('ShopTheLook__modal_close')) {
					el = el.closest('.ShopTheLook__modal_close');
				}
				e.preventDefault();
				const modalEl = el.closest('.ShopTheLook__modal');
				if (modalEl) {
					modalEl.classList.remove('active');
					document.body.classList.remove('popup-open');
				}
			}
		});
	}

	$('body').on('click', '.mega-menu__accordion_toggle', function(e) {
		e.preventDefault();
		const $parentEl = $(this).closest('.collapsible_nav_wrapper');
		const $menu__accordionEl = $parentEl.find('.mega-menu__accordion');

		$parentEl.toggleClass('active');
		$menu__accordionEl.slideToggle(300);

	});

	if(document.querySelector('.form-question-wrap input')) {
		$('.form-question-wrap input').on('change', function(e) {
			$('.request-form').toggleClass('active');
			$('.get-quote-form').toggleClass('active');
		})
	}	

	if (document.querySelector('.toggle_check_all_options_input')) {
		document.addEventListener('change', function(e) {
			var el = e.target;

			if (el.classList.contains('toggle_check_all_options_input')) {
				e.preventDefault();
				const is_checkedInput = el.checked;
				const facets_wrapEl = el.closest('ul');
				if (facets_wrapEl) {
					let facets__itemInputs = '';
					if (is_checkedInput) {
						facets__itemInputs = facets_wrapEl.querySelectorAll('[type="checkbox"]:not(.toggle_check_all_options_input):not(:checked)');
					} else {
						facets__itemInputs = facets_wrapEl.querySelectorAll('[type="checkbox"]:not(.toggle_check_all_options_input):checked');
					}

					if (facets__itemInputs.length) {
						for (itemInput of facets__itemInputs) {
							const labelInput = itemInput.closest('label');
							if (labelInput) {
								labelInput.click();
							}

						}
					}

				}
			}
		});
	}

	if (document.querySelector('.force_range_input')) {
		document.addEventListener('change', function(e) {
			var el = e.target;
			if (el.classList.contains('force_range_input')) {
				e.preventDefault();
				const min_val = parseFloat(el.getAttribute('data-min-value'));
				const max_val = parseFloat(el.getAttribute('data-max-value'));

				const facets_wrapEl = el.closest('ul');
				if (facets_wrapEl) {
					let facets__itemInputs = facets_wrapEl.querySelectorAll('[type="checkbox"]:not(.force_range_input)');
					if (facets__itemInputs.length) {
						for (const itemInput of facets__itemInputs) {
							const parce_input_val = parseFloat(itemInput.value);

							if (parce_input_val >= min_val && parce_input_val <= max_val) {
								const labelInput = itemInput.closest('label');
								if (labelInput) {
									labelInput.click();
								}
							}
						}
					}
				}
			}
		});
	}

	if (document.querySelector('.range-facet-remove--btn')) {
		document.addEventListener('click', function(e) {
			let el = e.target;

			if (el.classList.contains('range-facet-remove--btn') || el.closest('.range-facet-remove--btn')) {
				if (!el.classList.contains('range-facet-remove--btn')) {
					el = el.closest('.range-facet-remove--btn');
				}

				e.preventDefault();
				const btnIndex = el.getAttribute('data-index');
				const parentEl = el.closest('.facets-container');

				const activeFilterBtn = parentEl.querySelector('.force_range_input[data-range-type="' + btnIndex + '"]');

				if (activeFilterBtn) {
					activeFilterBtn.checked = false;
					activeFilterBtn.dispatchEvent(new Event('change', {
						bubbles: true
					}));
				}
			}
		});
	}

	if (document.querySelector('.resources__cntrl-search-input')) {
		$(".resources__cntrl-search-input").on("keyup", function(e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				$(this)
					.next(".resources__cntrl-search-button")
					.trigger("click");
			}
			if ($(this).val() == "") {
				$(this)
					.next(".resources__cntrl-search-button")
					.trigger("click");
			}
		});
	}


	if (document.querySelector('.resources__cntrl-search-button')) {
		$(".resources__cntrl-search-button:not(.faq)").on("click", function() {
			var k = $(this)
				.prev(".resources__cntrl-search-input")
				.val()
				.toLowerCase()
				.replace(/\s+/g, " ").replace(/^\s|\s$/g, "");
			k = k.split(' ');
			var found = 0;
			if (k != "") {
				$('.resources__item-block').removeClass('tabs__button--active');
				$('.tabs--wide').addClass('hide');
				$('.tabs--wide').each(function() {
					$this = $(this);
					var item = $(this).find(".col-item");
					item.fadeOut("fast");
					$(this).find(".col-item").each(function() {
						$(this).fadeOut("fast");
						$this_item = $(this);
						$.each(k, function() {
							if ($this_item.data("title").toLowerCase().indexOf(this) > -1 || $this_item.text().toLowerCase().indexOf(this) > -1) {
								$this.removeClass("hide");
								$this.find('.resources__item-block').addClass('tabs__button--active');
								$this_item.fadeIn("fast").addClass('test');
								found++;
							}
						});
					});
					if (found == 0) {
						$('.resources__item').hide();
						$('.empty-answer').addClass('active');
					} else {
						$('.resources__item').show();
						$('.empty-answer').removeClass('active');
					}
				});
			} else {
				$('.resources__item').show();
				$('.empty-answer').removeClass('active');
				$(".col-item").show();
				$('.tabs--wide').removeClass("hide");
				$('.resources__item-block').removeClass('tabs__button--active');
			}
		});
	}


	const btn = $('#topButton');
	if (btn.length) {
		let scrollHeight = Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);

		$(window).scroll(function() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > (scrollHeight / 3)) {
				btn.addClass('show');
			} else {
				btn.removeClass('show');
			}
		});
		btn.on('click', function(e) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: 0
			}, '1000');
		});
	}


	if (document.querySelector('.tabs .tabs__button')) {
		$("body").on("click", ".tabs .tabs__button", function(e) {
			e.stopPropagation();
			// e.preventDefault();

			const is_tabs__button_toggle_media = $(this).hasClass('tabs__button_toggle_media');


			const is_section_anchor_btn = $(this).hasClass('section_anchor_btn');
			if (is_section_anchor_btn) {
				e.preventDefault();
				e.stopPropagation();

				const sectionClassName = $(this).attr('data-section-link');
				if (sectionClassName.length) {
					const anchor_sectionEL = $(`.${sectionClassName}`);
					if (anchor_sectionEL.length) {
						let offsetTop = anchor_sectionEL.offset().top - $('.header-wrapper').height();
						$('html, body').animate({
							scrollTop: offsetTop
						}, 1000);
					}
				}
				return false;
			}

			if (!$(this).hasClass("tabs__button--active")) {
				$(this).siblings(".tabs__button--active").removeClass("tabs__button--active");

				// if(is_tabs__button_toggle_media) {
				const parentTabsEl = $(this).closest('.tab_content_block');
				const prevActiveTabBtn = parentTabsEl.find(".tabs__button--active");
				if (prevActiveTabBtn.length) {
					prevActiveTabBtn.removeClass("tabs__button--active");
					prevActiveTabBtn.next(".tabs__item").slideUp(400);
				}
				// }
				if ($(this).parents(".tabs--wide").length) {
					$(this).siblings(".tabs__item:visible").slideUp(400);
					$(this).next(".tabs__item").slideDown(400);
				} else {
					$(this).siblings(".tabs__item:visible").slideUp(400);
					$(this).next(".tabs__item").slideDown(400);
				}
				$(this).addClass("tabs__button--active");
			} else if ($(this).hasClass("tabs__button--active")) {
				$(this).removeClass("tabs__button--active");
				$(this).next(".tabs__item").slideUp(400);
			}

			if ($(this).hasClass('tab__media_button')) {
				$('.product-articles-slider').slick("setPosition");
			}

			if (is_tabs__button_toggle_media) {
				const image_url = $(this).attr('data-tab_image');
				const video_url = $(this).attr('data-tab_video');
				const $parentEl = $(this).closest('.image_with_accordions_wrapper');
				const $sectionImageEl = $parentEl.find('.section__media_block img');
				const $sectionVideoEl = $parentEl.find('.section__media_block video');

				if (image_url) {
					if ($sectionImageEl.length) {
						$sectionImageEl.attr('src', image_url);
						$sectionImageEl.attr('srcset', image_url);
						$sectionImageEl.removeClass('hide');
					}
					if ($sectionVideoEl.length) {
						$sectionVideoEl.addClass('hide');
					}
				}

				if (video_url) {
					if ($sectionImageEl.length) {
						$sectionImageEl.addClass('hide');
					}
					if ($sectionVideoEl.length) {
						$sectionVideoEl.attr('src', video_url);
						$sectionVideoEl.removeClass('hide');
					}
				}
			}


			if ($(this).data("hash")) {
				window.history.pushState(
					null,
					null,
					window.location.pathname + $(this).data("hash")
				);
			}
		});
	}

	if (document.querySelector('.tabs__button-mob')) {
		var windWidth = $(window).width();
		var orientation = (window.screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
		if (windWidth <= 768 && (window.innerHeight > window.innerWidth) && $('.tabs__button-mob').length) {
			$('.tabs__button--active').removeClass('tabs__button--active');
			$('.tabs__button-mob').addClass('tabs__button--active');
		}
	}


	if ($('.product-articles-slider').length) {
		$('.product-articles-slider').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			adaptiveHeight: true,
			nextArrow: '<button type="button" class="slick-button-next product-articles-slider-next" aria-label="Next">' + window.assets.icon_right + '</button>',
			prevArrow: '<button type="button" class="slick-button-prev product-articles-slider-prev" aria-label="Previous">' + window.assets.icon_left + '</button>',
			responsive: [{
					breakpoint: 990,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}

	if (document.querySelector('.catalog-info__item-collapse')) {
		$(".catalog-info__item-collapse").on("click", function() {
			$(this).toggleClass('active').next().slideToggle(400);
		});
	}

	if (document.querySelector('.icon-with-text__item__link')) {
		$('body').on('click', '.icon-with-text__item__link', function(e) {

			const href = this.href;
			if (href.includes('#')) {
				e.preventDefault();
				const elemId = href.split('#')[1];
				const el = document.querySelector('#' + elemId);
				if (el) {

					let offsetTop = $(el).offset().top - 67;
					$('html, body').animate({
						scrollTop: offsetTop
					}, 1000);
				}
			}

		});
	}


	if (document.querySelector('#AjaxinateContainer')) {
		document.addEventListener('click', function(e) {
			let el = e.target;

			if (el.classList.contains('load-more__btn') || el.closest('.load-more__btn')) {
				if (!el.classList.contains('load-more__btn')) {
					el = el.closest('.load-more__btn');
				}
				el.classList.add('loading');
			}
		});
		const endlessScroll = new Ajaxinate({
			container: '#AjaxinateContainer',
			pagination: '#AjaxinatePagination',
			method: 'click',

			callback: function() {
				const load_more__btn = document.querySelector('.load-more__btn');
				if (load_more__btn) {
					load_more__btn.classList.remove('loading');
				}
			}
		});
	}

	if (document.querySelector('.toggle_selection_button')) {
		document.addEventListener('click', function(e) {
			let el = e.target;

			if (el.classList.contains('toggle_selection_button') || el.closest('.toggle_selection_button')) {
				if (!el.classList.contains('toggle_selection_button')) {
					el = el.closest('.toggle_selection_button');
				}
				e.preventDefault();
				el.classList.toggle('active');
			}
		});
	}

	if (document.querySelector('.iframe-wrapper')) {
		$(".iframe-wrapper").each((function() {
			0 == $(this).parents(".video-wrapper").length &&
				($(this).find('iframe[data-src*="youtube.com/embed"]').length > 0 ||
					$(this).find('iframe[src*="youtube.com/embed"]').length > 0) &&
				($(this).find("iframe").hasClass("responsive-video") ?
					$(this).addClass("responsive-video-wrapper") : $(this).addClass("video-wrapper"))
		}));
	}

	function setParam(key, value) {
		var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + key + '=' + value;
		window.history.replaceState({
			path: newurl
		}, '', newurl);
	}

	function LoadMoreBlog(num) {
		let totalNum = $(".blog__item.active-item").length;
		let totalPagNumber = parseInt(totalNum / 6);
		let prePagination = $(".pro-auto__pagination");
		if (prePagination == undefined) {
			return false;
		}
		let query = 'page';
		if ($('body').hasClass('template-blog')) {
			query = 'view';
		}
		let nextPageHref = prePagination.find('.btn-load-more').attr('href');
		let nextPageNum = parseInt(nextPageHref.split(query + '=')[1]);
		if (num != undefined) {
			nextPageNum = parseInt(num);
		}
		let counter = nextPageNum * 6;
		$(".blog__item.active-item").each(function(i) {
			let el = $(this);
			if (i >= counter) return false;
			if (el.is(':hidden')) {
				el.fadeIn();
			}
		});
		if ($(".blog__item.active-item:hidden").length == 0) {
			setParam(query, totalPagNumber);
			prePagination.hide();
			prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + +query + '=' + totalPagNumber);
		} else {
			setParam(query, nextPageNum);
			prePagination.show();
			prePagination.find('.btn-load-more').attr('href', nextPageHref.split(query + '=')[0] + query + '=' + (nextPageNum + 1));
		}
	}
	let querySearch = function getQueryParams() {
		let qs = document.location.search;
		qs = qs.split('+').join(' ');
		var params = {},
			tokens,
			re = /[?&]?([^=]+)=([^&]*)/g;
		while (tokens = re.exec(qs)) {
			params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
		}
		return params;
	}
	if ($('body').hasClass('template-blog') && querySearch.view != undefined ||
		$('body').hasClass('template-page') && querySearch.page != undefined) {
		LoadMoreBlog(querySearch.view || querySearch.page);
	}

	if (document.querySelector('.blog__content .btn-load-more')) {
		$(".blog__content .btn-load-more").on("click", function(e) {
			e.preventDefault();
			LoadMoreBlog();
		});
	}

	// function productsSlider() {
	// 	var slider = $('.products-slider');
	// 	var slidesCount
	// 	var progressBar = $('.progress-bar');
	// 	slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	// 		var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
	// 		progressBar
	// 			.css('background-size', calc + '% 100%')
	// 			.attr('aria-valuenow', calc);
	// 	});
	// 	slider.on('init', function(event, slick) {
	// 		slidesCount = slick.slideCount;
	// 		if (slidesCount < 10) {
	// 			$('.count').text('0' + slidesCount);
	// 		} else {
	// 			$('.count').text(slidesCount);
	// 		}
	// 	});
	// 	slider.slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		dots: true,
	// 		arrows: true
	// 	});


	// 	$('body').on('click', '.project-slider-button[data-slide]', function(e) {
	// 		e.preventDefault();
	// 		var slideno = $(this).data('slide');
	// 		$('.products-slider').slick('slickGoTo', slideno - 1);

	// 		var offsetTop;
	// 		offsetTop = $('.section-products').offset().top - $('.header-wrapper').height();

	// 		$('html, body').animate({
	// 			scrollTop: offsetTop
	// 		}, 1000);
	// 	});
	// };

  if(document.querySelector('.get-quote')) {
    $('body').on("click", ".get-quote", function(e) {
      e.preventDefault();
      $.fancybox.open({
        src: '#hbspt-form',
        type: 'inline',
        width: '100%',
        opts: {
          afterShow: function() {

          }
        }
      });
    });
  }


	const collaborations_footer_blockEl = document.querySelector('.collaborations_footer_block');
	if (collaborations_footer_blockEl) {
		const collabs_page__ctaEl = document.querySelector('.collabs-page__main .collabs-page__intro .collabs-page__cta');
		if (collabs_page__ctaEl) {
			collaborations_footer_blockEl.appendChild(collabs_page__ctaEl);

			const collabs_page__cta_mainEl = document.querySelector('.collabs-page__cta-main');
			if (collabs_page__cta_mainEl) {
				const collapsMainWrapperEl = document.querySelector('.collabs-page__main');
				if (collapsMainWrapperEl) {
					collapsMainWrapperEl.appendChild(collabs_page__cta_mainEl);
				}
			}

		}
	}



	let timeDelay = 40000;

	function checkAcceptCookies() {
		setTimeout(function() {
			if (!getCookie("promotions-popup") && ($('#promotions-popup-wrapper').length > 0)) {
				setCookie('promotions-popup', true, 1);
				$('#promotions-popup-wrapper').addClass('open');
				$('body').addClass('popup-open');
			}
		}, timeDelay);
	};
	//checkAcceptCookies();

	let timerId;
	if ($('#promotions-popup-wrapper').length > 0) {
		let showPopupBeforeCloseWindow = false;

		let timerCount = 0;
		timerId = setInterval(function() {
			timerCount += 1000;
			if (timerCount >= timeDelay) {
				showPopupBeforeCloseWindow = true;
				clearInterval(timerId);
			}
		}, 1000);

		$("body").mouseleave(function() {

			if (!getCookie("promotions-popup")) {

				$('#promotions-popup-wrapper').addClass('open');
				$('body').addClass('popup-open');
				setCookie('promotions-popup', true, 1);
				showPopupBeforeCloseWindow = true;
				clearInterval(timerId);
			}
		});


	}
  if(document.querySelector('.promotions-popup-close')) {
    $('.promotions-popup-close').on('click', function(ev) {
      ev.preventDefault();
      $('#promotions-popup-wrapper').removeClass('open');
      $('body').removeClass('popup-open');
      showPopupBeforeCloseWindow = true;

      clearInterval(timerId);
    });
  }

	const statistic_blocks_wrapperEl = document.querySelector('.statistic_blocks_wrapper');
	if (statistic_blocks_wrapperEl) {

    function isScrolledIntoView(elem) {
      let docViewTop = $(window).scrollTop();
      let docViewBottom = docViewTop + $(window).height();

      let elemTop = $(elem).offset().top;
      let elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    function timedCounter(finalValue, seconds, callback) {

      var startTime = (new Date).getTime();
      var milliseconds = seconds * 1000;

      (function update() {

        var currentTime = (new Date).getTime();
        var value = finalValue * (currentTime - startTime) / milliseconds;

        if (value >= finalValue)
          value = finalValue;
        else
          setTimeout(update, 0);

        callback && callback(value);

      })();
    }

		$(window).on('scroll.view_statistic_section', function() {
			if (isScrolledIntoView(statistic_blocks_wrapperEl)) {
				$(window).off('scroll.view_statistic_section');
				const statistic_block_numArr = statistic_blocks_wrapperEl.querySelectorAll('.statistic_block_num');
				if (statistic_block_numArr.length) {
					for (const statistic_block of statistic_block_numArr) {
						const finish_count = statistic_block.getAttribute('data-finish-count') * 1;
						const statistic_block_innerEl = statistic_block.querySelector('span');
						timedCounter(finish_count, 3, function(value) {
							statistic_block_innerEl.innerHTML = value.toFixed(1);
						});
					}
				}

			}
		});
	}

  if(document.querySelector('.multiple_tab_nav')) {
    $('body').on('click', '.multiple_tab_nav', function(e) {
      e.preventDefault();
      const $multiple_tabs = $(this).closest('.multiple_tabs');
      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      const current_tab_content_index = +($(this).attr('data-tab-index')) - 1;
      $multiple_tabs.find('.multiple_tab_content').removeClass('active');
      $($multiple_tabs.find('.multiple_tab_content')[current_tab_content_index]).addClass('active');
    });
  }
  if(document.querySelector('.multiple_tab_content_subnav_link')) {
    $('body').on('click', '.multiple_tab_content_subnav_link', function(e) {
      e.preventDefault();
      const $tabParentEl = $(this).closest('.multiple_tab_content');
      $(this).siblings().removeClass('active');
      $(this).siblings().removeClass('btn--primary').addClass('btn--secondary');
      $(this).removeClass('btn--secondary').addClass('active').addClass('btn--primary');
      const currentTab_subnav_content_tabs = $tabParentEl.find('.multiple_tab_content_subnav_content_tab');
      currentTab_subnav_content_tabs.removeClass('active');

      const current_tab_content_index = $(this).index();
      $(currentTab_subnav_content_tabs[current_tab_content_index]).addClass('active');

    });
  }

	if ($('.multiple_tabs').length) {
		const window_hash = window.location.hash;

		function openSelectedTab(hash) {
			const anchorElBtn = $('.multiple_tabs').find(hash);
			window.history.pushState({}, document.title, window.location.pathname);
			window.scrollTo(0, 0);
			setTimeout(function() {
				window.scrollTo(0, 0);
			}, 1);

			if (anchorElBtn.length) {
				const btnLvl = +(anchorElBtn.attr('data-tab-lvl'));
				anchorElBtn.click();
				if (btnLvl != 1) {
					const tabContentIndex = anchorElBtn.closest('.multiple_tab_content').attr('data-tab-index');
					const multiple_tab_navBtn = $('.multiple_tab_nav[data-tab-index="' + tabContentIndex + '"]');
					if (multiple_tab_navBtn.length) {
						multiple_tab_navBtn.click();
					}
				}
			}
		}

		$('body').on("click", "a[href*='" + window.location.pathname + "#']", function(e) {
			e.preventDefault();

			const href_id = $(this).attr('href').split(window.location.pathname)[1];
			openSelectedTab(href_id);
			if ($(this).closest('.menu-drawer').length) {
				const $menuDraver = $(this).closest('header-drawer');
				$menuDraver.find('summary')[0].click();
			}
		});

		if (window_hash.includes('#')) {
			openSelectedTab(window_hash);
		}
	}
  if(document.querySelector('.collection_grid_tabs_nav_button')) {
    $('body').on('click', '.collection_grid_tabs_nav_button', function(e) {
      e.preventDefault();
      const navbarEl = $(this).closest('.collection_grid_tabs_nav');
      const collection_grid_tabsEl = $(this).closest('.collection_grid_tabs');
      const prevActiveNavBtn = navbarEl.find('.collection_grid_tabs_nav_button.active');
      const activeIndex = $(this).closest('.collection_grid_tabs_nav_item').index();

      if (prevActiveNavBtn.length) {
        const prevActiveTabContentEl = collection_grid_tabsEl.find('.collection_grid_tab_content.active');
        prevActiveNavBtn.removeClass('active').addClass('btn--secondary');
        prevActiveTabContentEl.removeClass('active');
      }

      const activeTabContentEl = $(collection_grid_tabsEl.find('.collection_grid_tabs_content .collection_grid_tab_content')[activeIndex]);
      if (activeTabContentEl.length) {
        activeTabContentEl.addClass('active');
        $(this).addClass('active').removeClass('btn--secondary');
      }
    });
  }
  if(document.querySelector('.scrollTopBtn')) {
    $('body').on('click', '.scrollTopBtn', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  if(document.querySelector('.infographic_section-swatch')) {
    $('body').on('change', '.infographic_section-swatch', function(e) {
      const $sectionWrapperEl = $(this).closest('.infographic_section-wrap');
      const $sectionImageEl = $sectionWrapperEl.find('.infographic_section-image-wrapper img');
      const $sectionButtonEl = $sectionWrapperEl.find('.infographic_section-info-btn');

      const new_image_url = $(this).attr('data-image-url');
      const new_btn_link = $(this).attr('data-btn-link');

      $sectionImageEl.attr('src', new_image_url);
      $sectionImageEl.attr('srcset', new_image_url);
      $sectionButtonEl.attr('href', new_btn_link);
    });
  }


  if(document.querySelector('.overview-tabs-with-accordions .nav-tabs a')) {
    function setTabBorderPosition(elem) {
      const parentEl = elem.closest('.overview-tabs-with-accordions');
      const active_navEl = parentEl.querySelector('.nav-link.active');
      const TabBorder = parentEl.querySelector('.TabBorder');

      let tabBorder_offsetLeft = TabBorder.offsetLeft;
      let offsetWidth = active_navEl.offsetWidth;
      let offsetLeft = active_navEl.offsetLeft;

      offsetLeft = offsetLeft - tabBorder_offsetLeft;

      elem.style.setProperty('--tab-border-active-left', `${offsetLeft}px`);
      elem.style.setProperty('--tab-border-active-width', `${offsetWidth}px`);
    }
    const TabBorderActiveArr = document.querySelectorAll('.TabBorderActive');

    if (TabBorderActiveArr.length) {
      for (const tabBorderEl of TabBorderActiveArr) {
        setTabBorderPosition(tabBorderEl);
        window.addEventListener("resize", debounce(function(e) {
          setTabBorderPosition(tabBorderEl);
        }));
      }
    }


      $('body').on('click', '.overview-tabs-with-accordions .nav-tabs a', function(e) {
          e.preventDefault();

          const $parentEl = $(this).closest('.overview-tabs-with-accordions');
          $parentEl.find('.nav-tabs a').removeClass('active show');
          $parentEl.find('.tab-content .tab-pane').removeClass('active show');
          $($(this).attr('href')).addClass('active show');
          $(this).addClass('active show');

          const tabBorderEl = $parentEl[0].querySelector('.TabBorderActive');
          if (tabBorderEl) {
            setTabBorderPosition(tabBorderEl);
          }
      });
  }
  if(document.querySelector('.anchor_link_item')) {
    $('body').on('click', '.anchor_link_item, .anchor_btn_item', function(e) {

      if (!$(this).hasClass('full-unstyled-link')) {
        e.preventDefault();

        let scrollProgressBtn = false;
        let parentEl = $(this).closest('.anchor_links_nav_section') || $(this).closest('.scroll_bar_nav__section');

        if (parentEl.length == 0) {
          parentEl = $(this).closest('.scroll_bar_nav__section');
          scrollProgressBtn = true;
        }

        parentEl.find('.anchor_link_item').removeClass("active");
        $(this).addClass("active");
        const target = $(this).data('target-id');
        const is_tabs_mode = $(this).closest('.tabs_mode');
        const anchor_links_nav_section_wrapperEl = $(this).closest('.anchor_links_nav_section_wrapper');

        const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
        const section_height = parentEl.height() || 0;

        if (is_tabs_mode.length && parentEl.length) {

          const $anchor_nav_dividerEl = $('.anchor_nav_divider_tab[data-anchor_id="' + target + '"]');
          if ($anchor_nav_dividerEl.length) {
            const $anchor_nav_divider_section = $anchor_nav_dividerEl.closest('.anchor_nav_divider_section');

            const $prev_anchor_nav_divider_section = $anchor_nav_divider_section.prevAll('.anchor_nav_divider_section').first();

            if ($prev_anchor_nav_divider_section.length) {
              const $prev_active_sections = $prev_anchor_nav_divider_section.nextUntil('.anchor_nav_divider_section');

              if ($prev_active_sections.length) {
                $prev_active_sections.addClass('hideTabSection');
                $prev_active_sections.removeClass('activeTabSection');

              }
            } else {
              $('.activeTabSection').addClass('hideTabSection').removeClass('activeTabSection');
            }

            const $tabSections = $anchor_nav_divider_section.nextUntil('.anchor_nav_divider_section');
            if ($tabSections.length) {
              $tabSections.removeClass('hideTabSection');
              $tabSections.addClass('activeTabSection');
            }

            const parentNodeEl = anchor_links_nav_section_wrapperEl[0].parentNode;
            if (anchor_links_nav_section_wrapperEl[0] == parentNodeEl.firstElementChild) {
              $("html, body").animate({
                scrollTop: 0
              }, 1e3);
            } else {
              $("html, body").animate({
                scrollTop: (header_height - section_height)
              }, 1e3);
            }

          }
        } else {

          let scrollPosition = $(target).offset().top - header_height - section_height;
          if (scrollProgressBtn) {
            scrollPosition = scrollPosition - 90;
          }

          $("html, body").animate({
            scrollTop: (scrollPosition)
          }, 1e3);
        }
      }
    });
  }
  if(document.querySelector('.anchor_btn')) {
    $('body').on('click', '.anchor_btn', function(e) {
      e.preventDefault();

      const target = $(this).attr('data-anchor-link');
      const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
      $("html, body").animate({
        scrollTop: ($(target).offset().top - header_height)
      }, 1e3);
    });
  }
  if(document.querySelector('.tab_anchor_btn')) {
    $('body').on('click', '.tab_anchor_btn', function(e) {
      e.preventDefault();
      const popupId = $(this).attr('data-popup-id');
      const $popupEl = $('#' + popupId);

      const secondSlideHandle = $(this).attr('data-active-slide-handle');

      if ($popupEl.length) {
        if ($(this).hasClass('customizer_mode')) {
          let offsetTop = $popupEl.offset().top - 67;
          $('html, body').animate({
            scrollTop: offsetTop
          }, 1000);
        } else {

          if (secondSlideHandle) {
            const $nextStepSlide = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_2"][data-slide_heading="' + secondSlideHandle + '"]').first();

            if ($nextStepSlide.length) {
              $popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
              $nextStepSlide.addClass('active');
              checkSlideContentHeight($nextStepSlide);
            }
            $(this).removeAttr('data-active-slide-handle');
          }
          $popupEl.addClass('active');
        }
      }
    });
  }

	if ($('.anchor_nav_divider_section').length) {
		const $anchor_nav_divider_sectionArr = $('.anchor_nav_divider_section');
		$anchor_nav_divider_sectionArr.each(function(index) {
			const $tabSections = $(this).nextUntil('.anchor_nav_divider_section');
			if (index != 0) {
				if ($tabSections.length) {
					$tabSections.addClass('hideTabSection');
				}
			} else {
				$tabSections.addClass('activeTabSection');
			}

		});
	}
  if(document.querySelector('.hbspt_trigger_btn')) {
    $('body').on('click', '.hbspt_trigger_btn', function(e) {
      e.preventDefault();
      const el_ID = $(this).attr('href');
      $.fancybox.open({
        src: el_ID,
        type: 'inline',
        width: '100%',
        height: 'auto',
        opts: {
          afterShow: function() {

          }
        }
      });
    });
  }
  if(document.querySelector('.colorSwatchItem') || document.querySelector('.recently-viewed-slider')   ) {
    $('body').on('click', '.colorSwatchItem', function(e) {
      const variantImgSrc = $(this).attr('data-variant_image');
      const variantUrl = $(this).attr('data-variant_url');
      const $parentEl = $(this).closest('.card-wrapper');
      const $productImgEl = $parentEl.find('.card__media img');
      const $productBtnEl = $parentEl.find('.catalog-page__item-button');
      if ($productImgEl.length) {
        $productImgEl.attr('src', variantImgSrc);
        $productImgEl.attr('srcset', variantImgSrc);
      }
      if ($productBtnEl.length) {
        $productBtnEl.attr('href', variantUrl);
      }
    });
  }

  if(document.querySelector('.collapsible_usp_icon')) {
    $('body').on('click', '.collapsible_usp_icon', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
    });
  }
  if(document.querySelector('.industries-menu .lets-talk')) {
    $('body').on('click', '.industries-menu .lets-talk', function(e) {
      e.preventDefault();

      const popupId = $(this).attr('href');
      $.fancybox.open({
        src: popupId,
        type: 'inline',
        width: '100%',
        height: 'auto',
        opts: {
          afterShow: function() {

          }
        }
      });
    });
  }


	if (window.location.hash.indexOf('#ancholClicableE') != -1) {
		let anchorHandleEl = window.location.hash.split('#ancholClicableEl=')[1];

		if (anchorHandleEl.includes('&__hstc=')) {
			anchorHandleEl = anchorHandleEl.split('&__hstc=')[0];
		}

		let openSecondB2bSlide = false;
		let secondB2bSlideHandle = '';
		if (anchorHandleEl.includes('~~~~')) {
			secondB2bSlideHandle = anchorHandleEl.split('~~~~')[1];
			anchorHandleEl = anchorHandleEl.split('~~~~')[0];
			openSecondB2bSlide = true;

		}

		const decodedElHandle = decodeURI(anchorHandleEl);
		const anchorEl = $(decodedElHandle);
		let scroll_to_b2b_section = false;

		if (decodedElHandle.includes('subindustries_navigation_popup')) {
			scroll_to_b2b_section = true;
		}
		let scroll_el = anchorEl;
		if (scroll_to_b2b_section) {
			scroll_el = anchorEl.closest('.image_with_accordions_wrapper');
			const tabs__buttonEl = anchorEl.closest('.resources__item-block').find('.tabs__button');
			if (tabs__buttonEl.length) {
				tabs__buttonEl.click();
			}
		}

		window.history.pushState({}, document.title, window.location.pathname);
		if (anchorEl.length) {
			if (openSecondB2bSlide) {
				anchorEl.attr('data-active-slide-handle', secondB2bSlideHandle);
			}

			anchorEl.click();

			const header_height = parseFloat(document.documentElement.style.getPropertyValue('--header-height'));
			$("html, body").animate({
				scrollTop: (scroll_el.offset().top - header_height)
			}, 1e3).promise().done(function() {

			});
		}
	}

	function adaptiveHeader() {

		const window_width = window.innerWidth;
		if (window_width >= 1201) {
			if (document.body.classList.contains('show_tablet_nav')) {
				document.body.classList.remove('show_tablet_nav');
			}
			const header_navEl = document.querySelector('.section-header .header__inline-menu');
			const nav_height = parseFloat(header_navEl.offsetHeight);
			if (nav_height > 155) {
				document.body.classList.add('show_tablet_nav');
			} else {
				document.body.classList.remove('show_tablet_nav');
			}
			const sticky_headerEl = document.querySelector('sticky-header');
			if (sticky_headerEl) {
				sticky_headerEl.setHeaderHeight();
			}
			// window.dispatchEvent(new Event('resize', { bubbles: true }));
		}
	}
	adaptiveHeader();
	window.addEventListener("resize", debounce(function(e) {
		adaptiveHeader();
	}, 150));

	if ($('.subindustries_navigation_popup').length) {

		function checkSlideContentHeight(slideEl) {
			const $slideEl = $(slideEl);
			const contentHeight = $slideEl.find('.subindustries_navigation_popup__content').innerHeight();
			const popupWrapperHeight = $slideEl.closest('.subindustries_navigation_popup__wrapper').innerHeight();
			const $popupEl = $slideEl.closest('.subindustries_navigation_popup');
			if (popupWrapperHeight <= contentHeight || popupWrapperHeight >= window.innerHeight) {
				$popupEl.addClass('reduced');
			} else {
				$popupEl.removeClass('reduced');
			}
		}

		window.addEventListener("resize", debounce(function(e) {
			const activePopup = $('.subindustries_navigation_popup.active');
			if (activePopup.length) {
				const activePopupSlide = activePopup.find('.subindustries_navigation_popup_slide.active');
				if (activePopupSlide.length) {
					checkSlideContentHeight(activePopupSlide);
				}
			}
		}, 50));

		$('body').on('click', '.see_use_case_btn', function(e) {
			e.preventDefault();

			const $popupEl = $(this).closest('.subindustries_navigation_popup');
			const productHandle = $(this).closest('.ShopTheLook__ProductWrapperItem').attr('data-product-handle');

			const $nextStepSlide = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_2"][data-focal-point-index="' + productHandle + '"]').first();

			if ($nextStepSlide.length) {
				$popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
				$nextStepSlide.addClass('active');
				checkSlideContentHeight($nextStepSlide);
			}
		});
		$('body').on('click', '.see_product_btn', function(e) {
			e.preventDefault();
			const $popupEl = $(this).closest('.subindustries_navigation_popup');
			const productHandle = $(this).closest('.ShopTheLook__ProductWrapperItem').attr('data-product-handle');
			const $nextStepSlide = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_3"][data-focal-point-index="' + productHandle + '"]').first();

			if ($nextStepSlide.length) {
				$popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
				$nextStepSlide.addClass('active');
				checkSlideContentHeight($nextStepSlide);
			}
		});
		$('body').on('click', '.product-details_btn', function(e) {
			e.preventDefault();
			const $popupEl = $(this).closest('.subindustries_navigation_popup');
			const productHandle = $(this).closest('.subindustries_navigation_popup_slide').attr('data-focal-point-index');
			const $nextStepSlide = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_3"][data-focal-point-index="' + productHandle + '"]').first();

			if ($nextStepSlide.length) {
				$popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
				$nextStepSlide.addClass('active');
				checkSlideContentHeight($nextStepSlide);
			}
		});
		$('body').on('click', '.customize-specs_btn', function(e) {
			e.preventDefault();
			const $popupEl = $(this).closest('.subindustries_navigation_popup');
			const productHandle = $(this).closest('.subindustries_navigation_popup_slide').attr('data-focal-point-index');
			const $nextStepSlide = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_4"][data-focal-point-index="' + productHandle + '"]').first();

			if ($nextStepSlide.length) {
				$popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
				$nextStepSlide.addClass('active');
				checkSlideContentHeight($nextStepSlide);
			}
		});
		$('body').on('click', '.back_step_btn', function(e) {
			e.preventDefault();
			const $popupEl = $(this).closest('.subindustries_navigation_popup');
			const parentSlideIndex = $(this).closest('.subindustries_navigation_popup_slide').attr('data-block-type').split('_')[1] * 1;
			const productHandle = $(this).closest('.subindustries_navigation_popup_slide').attr('data-focal-point-index');
			let prevSlideIndex = parentSlideIndex - 1;
			let $prevSlideEl = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_' + prevSlideIndex + '"][data-focal-point-index="' + productHandle + '"]').first();

			if (!$prevSlideEl.length && prevSlideIndex > 1) {
				prevSlideIndex = prevSlideIndex - 1;
				$prevSlideEl = $popupEl.find('.subindustries_navigation_popup_slide[data-block-type="slide_' + prevSlideIndex + '"][data-focal-point-index="' + productHandle + '"]').first();
			}

			$popupEl.find('.subindustries_navigation_popup_slide').removeClass('active');
			if (prevSlideIndex == 1) {
				$popupEl.find('.subindustries_navigation_popup_slide[data-index="1"]').addClass('active');
				checkSlideContentHeight($popupEl.find('.subindustries_navigation_popup_slide[data-index="1"]'));
			} else {
				if ($prevSlideEl.length) {
					$prevSlideEl.addClass('active');
					checkSlideContentHeight($prevSlideEl);
				}
			}
		});
		$('body').on('click', '.section_additional_nav__item a', function(e) {
			e.preventDefault();
			const popupId = $(this).attr('data-popup-id');
			const $popupEl = $('#' + popupId);
			const windowHeight = window.innerHeight;
			const windowWidth = window.innerWidth;
			const $popupHeight = $popupEl.find('.subindustries_navigation_popup__wrapper').innerHeight();

			if ($popupEl.length) {
				if ($(this).hasClass('customizer_mode')) {
					let offsetTop = $popupEl.offset().top - 67;
					$('html, body').animate({
						scrollTop: offsetTop
					}, 1000);
				} else {
					if ($popupHeight >= windowHeight) {
						$popupEl.addClass('reduced');
					} else {
						$popupEl.removeClass('reduced');
					}
					$popupEl.addClass('active');
				}
			}
		});
		$('body').on('click', '.close_subindustries_navigation_popup', function(e) {
			e.preventDefault();
			$('.subindustries_navigation_popup').removeClass('active');
		});
		if ($('.subindustries_navigation_popup__media__slider').length) {
			$('.subindustries_navigation_popup__media__slider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: false
			});
		}
	}

	if (window.location.href.indexOf('#anchor__') >= 0) {
		const anchorBtnId = window.location.href.split('#anchor__')[1];
		const anchorBtnEl = document.querySelector('#anchor_btn__' + anchorBtnId);
		if (anchorBtnEl) {
			anchorBtnEl.click();
			window.history.pushState({}, document.title, window.location.pathname);
		}
	}
  if(document.querySelector('.section_main_nav__item a')) {
    $('body').on('click', '.section_main_nav__item a', function(e) {
      $(this).addClass('active_url');
    });
  }

	const $scroll_bar_nav__section = $('.scroll_bar_nav__section');
	if ($('.scroll_bar_nav__section').length) {

		function ScrollAnchorBarProgress() {
			const progressBar = document.querySelector('.scroll__progress_bar');
			const $anchor_point = $('.anchor_point');
			const min_scrollY = $anchor_point.first().offset().top;
			const max_scrollY = $anchor_point.last().offset().top;
			const windowY = window.scrollY;

			const headerHeight = document.querySelector('.section-header').clientHeight;
			const scroll_barHeight = document.querySelector('.scroll_bar_nav').clientHeight;
			const window_scroll_with_sticky_elems = windowY + headerHeight + scroll_barHeight + 100;
			const $scroll_bar_nav__section_links = $('.scroll_bar_nav__section .scroll_bar_nav_item');

			let progress_persent = (window_scroll_with_sticky_elems - min_scrollY) / (max_scrollY - min_scrollY) * 100;

			if (progress_persent < 0) {
				progress_persent = 0;
			} else if (progress_persent > 100) {
				progress_persent = 100;
			}

			progressBar.style.width = progress_persent + '%';

			if (window_scroll_with_sticky_elems >= 1) {
				$anchor_point.each(function(i) {
					if ($(this).offset().top <= window_scroll_with_sticky_elems) {
						$('.scroll_bar_nav__section .scroll_bar_nav_item .anchor_link_item.active').removeClass('active');
						$scroll_bar_nav__section_links.eq(i).find('.anchor_link_item').addClass('active');
					}
				});
			} else {
				$('.scroll_bar_nav__section .scroll_bar_nav_item .anchor_link_item.active').removeClass('active');
			}
		}
		ScrollAnchorBarProgress();
		window.addEventListener('scroll', ScrollAnchorBarProgress);
	}

    $('body').on('click', '.custom_popover_button', function(e) {
      e.preventDefault();

      const _this = $(this);

      let custom_popoverEl = $(this).next('.custom_popover');
      _this.toggleClass('active');

      if (custom_popoverEl.length) {
        if (_this.hasClass('active')) {
          custom_popoverEl.removeAttr('hidden');
        } else {
          custom_popoverEl.attr('hidden', true);
        }
      }
    });

	if ($('.custom_popover_button').length) {
		$(document).on('click', function(e) {
			if (!$(e.target).closest('.custom_popover, .custom_popover_button').length) {
				$('.custom_popover_button.active').each(function() {
					$(this).removeClass('active');
					$(this).next('.custom_popover').attr('hidden', true);
				});
			}
		});
	}


	$('body').on('blur', '.custom_popover_button', function() {
		const btn = $(this);
		const popover = btn.next('.custom_popover');

		setTimeout(() => {
			if (!btn.is(':focus') && !popover.is(':focus-within')) {
				btn.removeClass('active');
				popover.attr('hidden', true);
			}
		}, 0);
	});

	$('body').on('click', '.locale_code_switcher', function(e) {
		e.preventDefault();
		const isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
		const btn_href = $(this).attr('data-href');

		if (isMobile == "mobile") {
			const country_language_popoverEl = $(this).next('.country_language_popover');
			const prevActiveEl = $(this).closest('.custom_redirect_popover').find('.locale_code_switcher.active');

			if (prevActiveEl.length) {
				const prevActiveLanguagePopopver = prevActiveEl.next('.country_language_popover.active');

				if (prevActiveLanguagePopopver.length) {
					prevActiveLanguagePopopver.removeClass('active');
				}

				prevActiveEl.removeClass('active');

			}

			if (country_language_popoverEl.length) {
				$(this).addClass('active');
				country_language_popoverEl.addClass('active');
			} else {
				window.location.href = btn_href;
			}
		} else {
			window.location.href = btn_href;
		}
	});
	$('body').on('click', 'a[href*=".pdf"]', function(e) {
		const linkEl = this;

		const pdfModal = document.querySelector('#PopupModal-PDF-Viewer');
		if (pdfModal) {
			e.preventDefault();
			const link_href = linkEl.href;
			const pdfContentWrapperEl = pdfModal.querySelector('.popupModal-PDF-Viewer-content');
			pdfContentWrapperEl.innerHTML = '';
			const viewerUrl = "https://mozilla.github.io/pdf.js/web/viewer.html?file=" + encodeURIComponent(link_href);
			const iframe = document.createElement("iframe");
			iframe.src = viewerUrl;
			iframe.width = "100%";
			iframe.height = "100%";
			pdfContentWrapperEl.appendChild(iframe);
			pdfModal.show();
		}

	});
});
document.addEventListener("DOMContentLoaded", () => {
	const menuItems = document.querySelectorAll(".sticky_nav_item");
	if (menuItems.length) {
		const sections = Array.from(menuItems).map(link =>
			document.querySelector(link.getAttribute("href"))
		);

		const header = document.querySelector('.header-wrapper');

		function setActive(link) {
			document.querySelectorAll(".sticky_nav_menu li").forEach(li => {
				li.classList.remove("active");
			});



			const parentLi = link.closest("li");
			if (parentLi) {
				parentLi.classList.add("active");
			}
		}

		function scrollToSection(target) {
			const headerHeight = header ? header.offsetHeight : 0;
			const targetOffset = target.getBoundingClientRect().top + window.scrollY - headerHeight - 10;

			window.scrollTo({
				top: targetOffset,
				behavior: 'smooth'
			});
		}

		menuItems.forEach(link => {
			link.addEventListener("click", event => {
				event.preventDefault();

				const targetId = link.getAttribute("href");
				const targetSection = document.querySelector(targetId);

				if (targetSection) {
					scrollToSection(targetSection);

				}
			});
		});

		function checkVisibleSection() {
			const headerHeight = header ? header.offsetHeight : 0;
			const scrollY = window.scrollY + headerHeight + 50;

			let currentIndex = -1;

			sections.forEach((section, index) => {
				if (section && section.offsetTop <= scrollY) {
					currentIndex = index;
				}
			});

			if (currentIndex !== -1) {

				setActive(menuItems[currentIndex]);
			}
		}
		window.addEventListener("scroll", debounce(function(e) {
			checkVisibleSection();
		}, 50));
		checkVisibleSection();

		if (document.querySelectorAll(".content_column_block table").length) {
			document.querySelectorAll(".content_column_block table").forEach((table) => {
				const headers = [];

				const ths = table.querySelectorAll("thead tr:first-child th");
				ths.forEach((th) => headers.push(th.textContent.trim()));

				table.querySelectorAll("tbody tr").forEach((row) => {
					row.querySelectorAll("td").forEach((td, index) => {
						if (headers[index]) {
							td.setAttribute("data-label", headers[index]);
						}
					});
				});
			});
		}
	}


	const featured_video_grid_section = document.querySelector('.featured-video-grid-section');
	if (featured_video_grid_section) {
		const featured_video_grid_section_videosArr = featured_video_grid_section.querySelectorAll('video');

		featured_video_grid_section_videosArr.forEach((video, index) => {

			video.setAttribute('data-index', index);

			video.addEventListener('ended', function(e) {
				const parentEl = this.closest('.featured-video-block');
				const el_index = parseInt(this.getAttribute('data-index'));
				const block_btn = parentEl.querySelector('.toggle-video-btn');

				if (block_btn) {
					block_btn.classList.remove('active');
				}
				parentEl.classList.remove('active_block');

				const videoGridWrapper = this.closest('.featured-video-grid');
				let nextVideoEl = videoGridWrapper.querySelector(`video[data-index="${el_index+1}"`);

				if (!nextVideoEl) {
					nextVideoEl = featured_video_grid_section_videosArr[0];
				}
				if (nextVideoEl) {
					nextVideoEl.play();
				}

			});
			video.addEventListener('play', function(e) {

				const parentEl = this.closest('.featured-video-block');
				const block_btn = parentEl.querySelector('.toggle-video-btn');

				parentEl.classList.add('active_block');
				if (block_btn) {
					block_btn.classList.add('active');
				}
			});
		});

		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('toggle-video-btn') || el.closest('.toggle-video-btn')) {
				if (!el.classList.contains('toggle-video-btn')) {
					el = el.closest('.toggle-video-btn');
				}
				e.preventDefault();

				const sectionParent = el.closest('.featured-video-grid');
				const prevActiveVideoBlock = sectionParent.querySelector('.active_block');
				let prevActiveVideoBlockIndex = null;
				if (prevActiveVideoBlock) {
					prevActiveVideoBlockIndex = prevActiveVideoBlock.getAttribute('data-index');
				}

				const parentMediaEl = el.closest('.featured-video-block');
				const parentMediaElIndex = parentMediaEl.getAttribute('data-index');

				if (parentMediaElIndex != prevActiveVideoBlockIndex && prevActiveVideoBlockIndex != null) {

					prevActiveVideoBlock.classList.remove('active_block');
					const prevActiveVideoEl = prevActiveVideoBlock.querySelector('video');
					const prevActiveVideoBlockBtn = prevActiveVideoBlock.querySelector('.toggle-video-btn');
					if (prevActiveVideoEl) {
						prevActiveVideoEl.pause();
					}
					if (prevActiveVideoBlockBtn) {
						prevActiveVideoBlockBtn.classList.remove('active');
					}
				}

				const videoEl = parentMediaEl.querySelector('video');
				el.classList.toggle('active');

				if (el.classList.contains('active')) {
					parentMediaEl.classList.add('active_block');
					videoEl.play();
				} else {
					parentMediaEl.classList.remove('active_block');
					videoEl.pause();
				}
			}
		});
	}


	const fadein_sectionEl = document.querySelector('.fadein_section_inner_wrapper');
	if (fadein_sectionEl) {
		const sections = fadein_sectionEl.querySelectorAll('.fadein_section_content_column');

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry, index) => {
				if (entry.isIntersecting) {
					setTimeout(() => {
						entry.target.classList.add('in-view');
					}, index * 1000);
					obs.unobserve(entry.target);
				}
			});
		}, {
			threshold: 0.2
		});

		sections.forEach(section => observer.observe(section));
	}

	const navLinks = document.querySelectorAll(".anchor_link_item");
	if (navLinks.length) {
		const is_tabs_mode = navLinks[0].closest('.tabs_mode');
		if (!is_tabs_mode) {
			function anchorViewport() {
				let currentSection = "";

				navLinks.forEach(link => {
					const targetSelector = link.dataset.targetId;

					if (!targetSelector) return;

					const targetElement = document.querySelector(targetSelector);
					if (!targetElement) return;

					const rect = targetElement.getBoundingClientRect();
					if (rect.top <= window.innerHeight / 3 && rect.bottom >= window.innerHeight / 3) {
						currentSection = targetSelector;
					}
				});

				if (currentSection) {
					navLinks.forEach(link => {
						const targetSelector = link.dataset.targetId;
						if (!targetSelector) return;

						if (targetSelector === currentSection) {
							link.classList.add("active");
						} else {
							link.classList.remove("active");
						}
					});
				}
			}
			anchorViewport();
			window.addEventListener("scroll", anchorViewport);
		}
	}
  if(document.querySelector('.close_custom_product_submit_popup')) {
    document.addEventListener('click', function(e) {
      let el = e.target;
      if (el.classList.contains('close_custom_product_submit_popup') || el.closest('.close_custom_product_submit_popup')) {
        if (!el.classList.contains('close_custom_product_submit_popup')) {
          el = el.closest('.close_custom_product_submit_popup');
        }

        e.preventDefault();

        const modalEl = document.querySelector('.custom_product_submit_popup');
        if (modalEl) {
          modalEl.classList.add('hide');
          document.body.classList.remove('popup-open');
        }
      }
    });
  }

	const $search_pages_results_countEl = $('.search_tab_block-pages-results-count');
	if ($search_pages_results_countEl.length) {
		const parentEl = $search_pages_results_countEl.closest('.search_tab_block');
		const pages_listArr = parentEl.find('.pages-list > li');
		$search_pages_results_countEl.html(pages_listArr.length);
	}

	if(document.querySelector('.tech_toggle_btn')) {
		document.addEventListener('click', function(e) {
			let el = e.target;
			if (el.classList.contains('tech_toggle_btn') || el.closest('.tech_toggle_btn')) {
			if (!el.classList.contains('tech_toggle_btn')) {
				el = el.closest('.tech_toggle_btn');
			}

			e.preventDefault();

			let prevActiveItemID = '';
			const sectionWrapperEl = el.closest('.section_blocks_wrapper');
			const parentEl = el.closest('.section_block');
			if(sectionWrapperEl) {
				const prevActiveEl = sectionWrapperEl.querySelector('.section_block.active');
				if(prevActiveEl) {
					prevActiveItemID = prevActiveEl.id;
					prevActiveEl.classList.remove('active');
				}
			}
			if (parentEl) {
				const parentId = parentEl.id;
				if(prevActiveItemID != parentId) {
					parentEl.classList.add('active');
				}
			}
			}
		});
	}
});

document.addEventListener('DOMContentLoaded', function() {
	const unitToggle = document.getElementById('unit-toggle');
	if (unitToggle) {
		const unit_switcher__active_labels = document.querySelectorAll('.unit_switcher__active_label');
		const custom_unit_switcher_btns = document.querySelectorAll('.custom_unit_switcher_popover .units_item');

		/* =====================================================
		 * 1. MULTI-LANGUAGE UNIT ALIASES 
		 * ===================================================== */
		const unitAliases = {
			inch: [
				// EN
				'inch', 'inches', 'in', '"', '”',
				// DE
				'zoll',
				// FR
				'pouce', 'pouces', 'po',
				// IT
				'pollice', 'pollici',
				// ES
				'pulgada', 'pulgadas', 'pulg',
				// PT-BR
				'polegada', 'polegadas', 'pol',
				// NL
				'inch', 'inches',
				// PL
				'cal', 'cale', 'cali',
				// SK
				'palec', 'palce',
				// SL
				'palci'
			],

			lbs: [
				// abbreviations
				'lb', 'lbs',
				// DE
				'pfund',
				// FR
				'livre', 'livres',
				// NL
				'pond', 'ponden',
				// PL
				'funt', 'funty',
				// ES
				'libras',
				// IT
				'libbre'
			],

			pounds: [
				// EN full
				'pound', 'pounds',
				// IT
				'libbra', 'libbre',
				// ES
				'libra', 'libras',
				// PT-BR
				'libra', 'libras',
				// SK
				'libra', 'libry'
			],

			ft: [
				// EN
				'ft', 'foot', 'feet',
				// DE
				'fuß', 'fuss',
				// FR
				'pied', 'pieds',
				// IT
				'piede', 'piedi',
				// ES
				'pie', 'pies',
				// PT-BR
				'pé', 'pés',
				// NL
				'voet', 'voeten',
				// PL
				'stopa', 'stopy',
				// SK
				'stopa', 'stopy'
			]
		};

		/* =====================================================
		 * 2. CANONICAL CONVERSIONS 
		 * ===================================================== */
		const conversions = {
			inch: {
				factor: 2.54,
				unitMetric: 'cm',
				unitImperial: 'inch'
			},
			lbs: {
				factor: 0.453592,
				unitMetric: 'kg',
				unitImperial: 'lbs'
			},
			pounds: {
				factor: 0.453592,
				unitMetric: 'kg',
				unitImperial: 'pounds'
			},
			ft: {
				factor: 0.3048,
				unitMetric: 'm',
				unitImperial: 'ft'
			}
		};

		/* =====================================================
		 * 3. REGEX HELPERS
		 * ===================================================== */
		function escapeRegex(str) {
			return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		}

		function buildUnitRegex(unitKey) {
			const aliases = unitAliases[unitKey]
				.map(escapeRegex)
				.join('|');
			const numberPattern = '\\d+(?:[.,]\\d+)*';

			return new RegExp(
				`(${numberPattern}(?:\\s*(?:-|–|to|a)\\s*${numberPattern})?\\+?)\\s*(?:${aliases})\\b`,
				'gi'
			);
		}


		/* =====================================================
		 * 4. NUMBER HELPERS
		 * ===================================================== */
		function normalizeNumber(str) {
			if (str == null) return null;

			let s = String(str).trim();
			if (!s) return null;

			if (s.includes(',') && s.includes('.')) {
				if (s.lastIndexOf(',') > s.lastIndexOf('.')) {
					s = s.replace(/\./g, '').replace(',', '.');
				} else {
					s = s.replace(/,/g, '');
				}
			} else if (s.includes(',')) {
				s = s.replace(',', '.');
			}

			const num = parseFloat(s);
			return isNaN(num) ? null : num;
		}

		function convertSingleNumber(numStr, unit, toMetric) {
			const num = normalizeNumber(numStr);
			const conv = conversions[unit];
			if (num === null || !conv) return null;
			const val = toMetric ? (num * conv.factor) : num;
			return `${val.toFixed(2)} ${toMetric ? conv.unitMetric : conv.unitImperial}`;
		}

		function convertValueWithUnit(rawValue, unit, toMetric) {
			const value = rawValue.trim();

			const rangeMatch = value.match(
				/^([\d.,]+)\s*(?:-|–|to|a)\s*([\d.,]+)$/i
			);

			if (rangeMatch) {
				const leftRaw = rangeMatch[1];
				const rightRaw = rangeMatch[2];

				const left = convertSingleNumber(leftRaw, unit, toMetric);
				const right = convertSingleNumber(rightRaw, unit, toMetric);

				if (left && right) {
					const leftNum = left.split(' ')[0];
					const rightFull = right; // вже з unit
					return `${leftNum}-${rightFull}`;
				}
			}


			if (/\+$/.test(value)) {
				const base = value.replace(/\+$/, '');
				const converted = convertSingleNumber(base, unit, toMetric);
				if (converted) {
					const [numPart, unitPart] = converted.split(' ');
					return `${numPart}+ ${unitPart}`;
				}
				return value + ' ' + unit;
			}

			const converted = convertSingleNumber(value, unit, toMetric);
			return converted ?? (value + ' ' + unit);
		}

		/* =====================================================
		 * 5. CONVERT TEXT
		 * ===================================================== */
		function convertText(text, toMetric = true) {
			if (!text || typeof text !== 'string') return text;

			text = text.replace(
				/\(([^)]*?)([\d.,]+)\s*["”]\s*[-–]\s*([\d.,]+)\s*["”]([^)]*?)\)/g,
				(m, before, v1, v2, after) => {
					const n1 = normalizeNumber(v1);
					const n2 = normalizeNumber(v2);
					if (n1 === null || n2 === null) return m;
					const a = toMetric ? (n1 * conversions.inch.factor).toFixed(2) : n1.toFixed(2);
					const b = toMetric ? (n2 * conversions.inch.factor).toFixed(2) : n2.toFixed(2);
					const unit = toMetric ? conversions.inch.unitMetric : conversions.inch.unitImperial;
					return `(${before}${a} ${unit} – ${b} ${unit}${after})`;
				}
			);

			text = text.replace(
				/\(([^)]*?)([\d.,]+)\s*["”](\+)?([^)]*?)\)/g,
				(m, before, v, plus, after) => {
					const n = normalizeNumber(v);
					if (n === null) return m;
					const val = toMetric ? (n * conversions.inch.factor).toFixed(2) : n.toFixed(2);
					const unit = toMetric ? conversions.inch.unitMetric : conversions.inch.unitImperial;
					return `(${before}${val}${plus ? '+' : ''} ${unit}${after})`;
				}
			);

			text = text.replace(/([\d.,]+)\s*["”](\+)?/g, (m, v, plus) => {
				const n = normalizeNumber(v);
				if (n === null) return m;
				const val = toMetric ? (n * conversions.inch.factor).toFixed(2) : n.toFixed(2);
				const unit = toMetric ? conversions.inch.unitMetric : conversions.inch.unitImperial;
				return `${val}${plus ? '+' : ''} ${unit}`;
			});

			text = text.replace(/([\d.,]+)\s*['′](\+)?/g, (m, v, plus) => {
				const n = normalizeNumber(v);
				if (n === null) return m;
				const val = toMetric ? (n * conversions.ft.factor).toFixed(2) : n.toFixed(2);
				const unit = toMetric ? conversions.ft.unitMetric : conversions.ft.unitImperial;
				return `${val}${plus ? '+' : ''} ${unit}`;
			});

			// 4) MULTI-LANGUAGE UNITS
			text = text.replace(buildUnitRegex('inch'), (m, v) => convertValueWithUnit(v, 'inch', toMetric));
			text = text.replace(buildUnitRegex('lbs'), (m, v) => convertValueWithUnit(v, 'lbs', toMetric));
			text = text.replace(buildUnitRegex('pounds'), (m, v) => convertValueWithUnit(v, 'pounds', toMetric));
			text = text.replace(buildUnitRegex('ft'), (m, v) => convertValueWithUnit(v, 'ft', toMetric));

			return text;
		}

		function looksImperialValue(value) {
			if (!value) return false;
			if (/\d+(?:[.,]\d+)*\s*["”]/.test(value)) return true;
			if (/\d+(?:[.,]\d+)*\s*['′]/.test(value)) return true;
			return Object.values(unitAliases).some(list =>
				list.some(alias =>
					new RegExp(`\\b\\d+(?:[.,]\\d+)*\\s*${escapeRegex(alias)}\\b`, 'i').test(value)
				)
			);
		}

		function looksMetricValue(value) {
			if (!value) return false;
			return /\b(cm|kg|m)\b/i.test(value);
		}

		/* =====================================================
		 * 6. MARK ORIGINALS (MULTI-LANGUAGE)
		 * ===================================================== */
		function markFacetOriginals(root = document.body) {
			root.querySelectorAll('.facet-checkbox span[aria-hidden="true"]').forEach(span => {
				const text = span.textContent?.trim();
				if (!text) return;

				const hasUnits =
					/\d/.test(text) &&
					Object.values(unitAliases).some(list =>
						list.some(alias =>
							new RegExp(escapeRegex(alias), 'i').test(text)
						)
					);

				if (!hasUnits) return;

				if (!span.hasAttribute('data-original')) {
					span.setAttribute('data-original', text);
				}
			});
		}

		function markOriginals(root = document.body) {
			const EXCLUDED_PARENTS = ['header', 'nav'];

			const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);

			while (walker.nextNode()) {
				const node = walker.currentNode;
				const parent = node.parentElement;
				if (!parent) continue;

				const tag = parent.tagName.toLowerCase();
				if (['script', 'style', 'noscript'].includes(tag)) continue;

				if (EXCLUDED_PARENTS.some(t => parent.closest(t))) continue;

				const text = node.nodeValue;
				if (!text || !text.trim()) continue;

				const hasUnits = (
					/[\d.,]+\s*["”]/.test(text)

					||
					/[\d.,]+\s*['′]/.test(text)

					||
					/[\d.,]+\s*["”]\s*(?:to|a)\s*[\d.,]+\s*["”]/i.test(text)

					||
					/[\d.,]+\s*["”]\s*\/\s*(?:s|sec|seg)/i.test(text)

					||
					Object.values(unitAliases).some(list =>
						list.some(alias =>
							new RegExp(
								`\\b\\d+(?:[.,]\\d+)*\\s*(?:${escapeRegex(alias)})\\b`,
								'i'
							).test(text)
						)
					)
				);



				if (!hasUnits) continue;

				const visibleText = parent.innerText?.trim();
				if (!visibleText) continue;

				if (!parent.hasAttribute('data-original')) {
					parent.setAttribute('data-original', visibleText);
				}
				if (!parent.hasAttribute('data-original-html')) {
					parent.setAttribute('data-original-html', parent.innerHTML);
				}
			}
		}

		function convertTextNodesInElement(element, toMetric) {
			const textWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
			const textNodes = [];

			while (textWalker.nextNode()) {
				const textNode = textWalker.currentNode;
				const textParent = textNode.parentElement;
				if (!textParent) continue;

				const parentTag = textParent.tagName.toLowerCase();
				if (['script', 'style', 'noscript'].includes(parentTag)) continue;

				textNodes.push(textNode);
			}

			textNodes.forEach(textNode => {
				textNode.nodeValue = convertText(textNode.nodeValue, toMetric);
			});
		}


		/* =====================================================
		 * 7. UPDATE PAGE
		 * ===================================================== */
		let isInternalUpdate = false;
		let observer = null;
		const observerRoot = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
		const nodeMayContainUnits = (node) => {
			if (!node || node.nodeType !== 1) return false;
			const text = node.textContent;
			if (!text || !/\d/.test(text)) return false;

			if (/\d+(?:[.,]\d+)*\s*["”'′]/.test(text)) return true;
			return Object.values(unitAliases).some(list =>
				list.some(alias =>
					new RegExp(`\\b\\d+(?:[.,]\\d+)*\\s*${escapeRegex(alias)}\\b`, 'i').test(text)
				)
			);
		};
		const startObserver = () => {
			if (!observer) return;
			observer.observe(observerRoot, {
				childList: true,
				subtree: true
			});
		};

		function updatePageUnits() {
			if (isInternalUpdate) return;
			isInternalUpdate = true;
			if (observer) observer.disconnect();
			try {
			const toMetric = unitToggle.value === 'metric';

			unit_switcher__active_labels.forEach(unit_label => {
				const inch_value_label = unit_label.getAttribute('data-inch-label');
				const metric_value_label = unit_label.getAttribute('data-metric-label');
				unit_label.innerHTML = toMetric ? metric_value_label : inch_value_label;
			});


			// 1️⃣ 
			document.querySelectorAll('[data-original]').forEach(el => {
				const original = el.getAttribute('data-original');
				const originalHtml = el.getAttribute('data-original-html');

				if (originalHtml !== null) {
					el.innerHTML = originalHtml;
					if (toMetric) {
						convertTextNodesInElement(el, true);
					}
					return;
				}

				el.textContent = toMetric ? convertText(original, true) : original;
			});

			// 2️⃣
			document.querySelectorAll('.catalog-page__item-table-tr').forEach(row => {
				const spans = row.querySelectorAll('span');

				if (spans.length < 2) return;

				const labelEl = spans[0];
				const valueEl = spans[1];


				if (!labelEl.hasAttribute('data-original-label')) {
					labelEl.setAttribute('data-original-label', labelEl.textContent.trim());
				}
				const dataOriginal = valueEl.getAttribute('data-original');
				const dataOriginalImperial = valueEl.getAttribute('data-original-imperial');
				const dataOriginalValue = valueEl.getAttribute('data-original-value');
				const textValue = valueEl.textContent.trim();

				let imperialSource = dataOriginalImperial;
				if (!imperialSource) {
					if (dataOriginal && (looksImperialValue(dataOriginal) || !looksMetricValue(dataOriginal))) {
						imperialSource = dataOriginal;
					} else if (dataOriginalValue && looksImperialValue(dataOriginalValue)) {
						imperialSource = dataOriginalValue;
					} else if (textValue && looksImperialValue(textValue)) {
						imperialSource = textValue;
					} else {
						imperialSource = dataOriginal || dataOriginalValue || textValue;
					}
				}

				if (!dataOriginalImperial && imperialSource) {
					valueEl.setAttribute('data-original-imperial', imperialSource);
				}

				const originalValueAttr = imperialSource;
				if (!valueEl.hasAttribute('data-original-value')) {
					valueEl.setAttribute('data-original-value', originalValueAttr);
				}

				const originalLabel = labelEl.getAttribute('data-original-label') || '';
				const originalValue = originalValueAttr;
				const lowerLabel = originalLabel.toLowerCase();
				const num = normalizeNumber(originalValue);

				let detectedUnit = null;


				for (const unitKey of ['inch', 'lbs', 'pounds', 'ft']) {
					const aliases = unitAliases[unitKey] || [];
					if (aliases.some(alias =>
							new RegExp(`\\(${escapeRegex(alias)}\\)`, 'i').test(lowerLabel)
						)) {
						detectedUnit = unitKey;
						break;
					}
				}


				if (detectedUnit && num !== null) {
					const conv = conversions[detectedUnit];


					labelEl.textContent = toMetric ?
						originalLabel.replace(/\(([^)]+)\)/, `(${conv.unitMetric})`) :
						originalLabel;


					valueEl.textContent = toMetric ?
						(num * conv.factor).toFixed(2) :
						originalValue;

				} else {
					labelEl.textContent = originalLabel;
					valueEl.textContent = toMetric ?
						convertText(originalValue, true) :
						originalValue;
				}
			});

			// 3️⃣ localStorage
			localStorage.setItem('preferredUnit', toMetric ? 'metric' : 'imperial');
			} finally {
				isInternalUpdate = false;
				startObserver();
			}
		}


		const savedUnit = localStorage.getItem('preferredUnit') || 'imperial';
		unitToggle.value = savedUnit;

		markOriginals();
		markFacetOriginals();
		updatePageUnits();
		unitToggle.addEventListener('change', updatePageUnits);

		custom_unit_switcher_btns.forEach(unit_btn => {
			unit_btn.addEventListener('click', function(e) {
				e.preventDefault();
				const btn_value = this.getAttribute('data-value');
				unitToggle.value = btn_value;
				unitToggle.dispatchEvent(new Event('change', {
					bubbles: true
				}));
			});

		});

		let updateScheduled = false;
			const scheduleUpdate = () => {
				if (updateScheduled) return;
				updateScheduled = true;
				requestAnimationFrame(() => {
					updateScheduled = false;
					if (isInternalUpdate) return;
					updatePageUnits();
				});
			};

		observer = new MutationObserver(mutations => {
					if (isInternalUpdate) return;
					let hasRelevantNodes = false;
					mutations.forEach(m => {
						m.addedNodes.forEach(node => {
							if (node.nodeType !== 1) return;
							if (!nodeMayContainUnits(node)) return;

							hasRelevantNodes = true;
							markOriginals(node);
							markFacetOriginals(node);
					});
				});
				if (hasRelevantNodes) {
					scheduleUpdate();
				}
			});

		startObserver();

	}
});

document.addEventListener('DOMContentLoaded', () => {

	// Stashes the product SKU so the resources page's 3D models search can pick it up after navigating via the hash link.
	if(document.querySelector('.find_3d_model_link')) {
		document.addEventListener('click', function(event) {
			const find3dModelLinkEl = event.target.closest('.find_3d_model_link');
			if (!find3dModelLinkEl) return;

			const sku = find3dModelLinkEl.getAttribute('data-model-sku');
			if (sku) {
				localStorage.setItem('find_3d_model_sku', sku);
			}
		});
	}

	
	const models3dSearchFormEl = document.querySelector('#models_3d_search_form');
	if (!models3dSearchFormEl) return;

	const models3dSearchInputEl = models3dSearchFormEl.querySelector('.models_3d_search_input');
	const models3dSearchBtnEl = models3dSearchFormEl.querySelector('.models_3d_search_btn');
	const models3dSearchPopoverWrapperEl = models3dSearchFormEl.querySelector('.models_3d_search_form_popover_wrapper');
	const models3dSearchPopoverInnerWrapperEl = models3dSearchFormEl.querySelector('.models_3d_search_form_popover_inner_wrapper');
	const model3dLinksArr = models3dSearchFormEl.querySelectorAll('.model_3d_link');
	const models3dDataScriptEl = document.querySelector('#models_3d_data');
	const models3dNotFoundEl = models3dSearchFormEl.querySelector('.search_status_wrapper .not_matched');

	if (!models3dSearchInputEl || !models3dSearchPopoverWrapperEl || !models3dSearchPopoverInnerWrapperEl) return;

	// Built once at load: {title, category, el} per link, in the same order the links were rendered, so
	// keystroke filtering never has to re-read attributes off ~400 DOM nodes.
	let models3dData = [];
	if (models3dDataScriptEl) {
		try {
			models3dData = JSON.parse(models3dDataScriptEl.textContent);
		} catch (e) {
			models3dData = [];
		}
	}
	// Fuzzy match: strip everything but letters/digits so "pa-01", "pa 01" and "pa01" are equivalent.
	const normalizeSearchValue = str => str.toLowerCase().replace(/[^a-z0-9]/g, '');
	const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	// Builds a regex that matches the searched characters even when separated by dashes/spaces in the target text.
	const buildFuzzyRegex = normalized => new RegExp(`(${normalized.split('').map(escapeRegex).join('[-\\s]*')})`, 'gi');

	const model3dItemsArr = models3dData.map((data, index) => {
		const title = data.title || '';
		// The last "-segment" of the title is the file extension (dwg/stp/sldprt/...); everything before it is the model name.
		const titleParts = title.split('-');
		const base = titleParts.length > 1 ? titleParts.slice(0, -1).join('-') : title;

		const category = data.category || '';

		return {
			title,
			base,
			category,
			el: model3dLinksArr[index],
			normTitle: normalizeSearchValue(title),
			normCategory: normalizeSearchValue(category)
		};
	});
	const matchesSearch = (item, normalizedSearch) => item.normTitle.includes(normalizedSearch) || item.normCategory.includes(normalizedSearch);

	models3dSearchInputEl.addEventListener('input', function(event) {
		const val = event.target.value;

		// Reset any results left visible from a previous submit so they don't linger while the user types a new search.
		model3dItemsArr.forEach(item => {
			if (item.el && !item.el.classList.contains('hide')) {
				item.el.classList.add('hide');
			}
		});
		if (models3dNotFoundEl) models3dNotFoundEl.classList.remove('active');

		if (models3dSearchBtnEl) models3dSearchBtnEl.toggleAttribute('disabled', val.length <= 1);

		if (val.length <= 1) {
			models3dSearchPopoverWrapperEl.classList.remove('show');
			models3dSearchPopoverInnerWrapperEl.innerHTML = '';
			return;
		}

		const normalizedSearch = normalizeSearchValue(val);
		const regex = buildFuzzyRegex(normalizedSearch);

		const foundResults = model3dItemsArr.filter(item => matchesSearch(item, normalizedSearch));

		// Dedupe by base model name so "pa-01-dwg/-stp/-sldprt" show as a single "pa-01" suggestion.
		const groupedResults = [];
		const seenBases = new Set();
		foundResults.forEach(item => {
			if (seenBases.has(item.base)) return;
			seenBases.add(item.base);
			groupedResults.push(item);
		});

		models3dSearchPopoverInnerWrapperEl.innerHTML = '';

		if (groupedResults.length > 0) {
			models3dSearchPopoverInnerWrapperEl.innerHTML = groupedResults.map(result => {
				const fullText = `${result.base} - ${result.category}`;
				const highlightedText = fullText.replace(regex, '<span class="search_val">$1</span>');

				return `
					<div class="model_3d_row">
						<span class="model_3d_item" data-model-title="${result.base}">
							${highlightedText}
						</span>
					</div>
				`;
			}).join('');

			models3dSearchPopoverWrapperEl.classList.add('show');
		} else {
			models3dSearchPopoverWrapperEl.classList.remove('show');
		}
	});

	document.addEventListener('click', function(event) {
		if (models3dSearchPopoverWrapperEl.classList.contains('show') && !models3dSearchPopoverWrapperEl.contains(event.target) && event.target !== models3dSearchInputEl) {
			models3dSearchPopoverWrapperEl.classList.remove('show');
		}
	});

	document.addEventListener('click', function(event) {
		let el = event.target;
		if (el.classList.contains('model_3d_item') || el.closest('.model_3d_item')) {
			if (!el.classList.contains('model_3d_item')) {
				el = el.closest('.model_3d_item');
			}
			event.preventDefault();

			const modelTitle = el.getAttribute('data-model-title');
			models3dSearchInputEl.value = modelTitle;
			models3dSearchPopoverWrapperEl.classList.remove('show');
		}
	});

	if (models3dSearchBtnEl) {
		models3dSearchBtnEl.addEventListener('click', function(event) {
			event.preventDefault();

			const normalizedSearch = normalizeSearchValue(models3dSearchInputEl.value);
			let hasMatch = false;

			model3dItemsArr.forEach(item => {
				if (!item.el) return;
				if (matchesSearch(item, normalizedSearch)) {
					item.el.classList.remove('hide');
					hasMatch = true;
				} else {
					item.el.classList.add('hide');
				}
			});

			if (models3dNotFoundEl) models3dNotFoundEl.classList.toggle('active', !hasMatch);

			models3dSearchPopoverWrapperEl.classList.remove('show');
		});
	}

	// Populates and triggers the search when arriving from a product page's "find 3D model" link (see click handler below).
	const pendingModelSku = localStorage.getItem('find_3d_model_sku');
	if (pendingModelSku) {
		localStorage.removeItem('find_3d_model_sku');
		models3dSearchInputEl.value = pendingModelSku;
		models3dSearchInputEl.dispatchEvent(new Event('input', { bubbles: true }));
		if (models3dSearchBtnEl) models3dSearchBtnEl.click();
	}

});
